import { useRouteError } from 'react-router-dom';
import { ErrorFallback } from '@/components/ErrorFallback';

/**
 * Wrapper component for React Router errorElement
 * Provides proper error handling for route-level errors
 */
export function RouteErrorBoundary() {
  const error = useRouteError() as Error;
  return (
    <ErrorFallback error={error} resetError={() => window.location.reload()} />
  );
}
